// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".gantt-container {\n  height: calc(100vh - 50px - 200px);\n}", "",{"version":3,"sources":["Gantt.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC","file":"Gantt.css","sourcesContent":[".gantt-container {\n  height: calc(100vh - 50px - 200px);\n}"]}]);
// Exports
module.exports = exports;
